import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Row, Col, Form, FormGroup, Label, Input, } from "reactstrap";
import html2canvas from 'html2canvas';
import api from "../../Axios";
import Pdf from "react-to-pdf";
import moment from "moment";
import Datatable from "react-bs-datatable";
import ColorPicker from "rc-color-picker";
import { noop } from "jquery";
import jsPDF from 'jspdf';
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import { Modal, Button } from 'react-bootstrap';
import Swal from "sweetalert2/dist/sweetalert2.js";
const ref = React.createRef();
const ViewCancelOrders = () => {


  
  const params = useParams();
  const [data, setData] = useState();
  // const[productName,se]
  const [table, setTable] = useState();
  const [courierId, setCourierId] = useState("");
  const [courierIdData, setCourierIdData] = useState("");
  const [courierName, setCourierName] = useState("");
  const [gst, setGST] = useState("");
  const [courierNameData, Data] = useState("");

  const[paymentStatus1, setPaymentStatus1] = useState("")
  const[orderStatus1, setOrderStatus1] = useState("");
  const[orderStatus, setOrderStatus] = useState("");
  const[paidAmount, setPaidAmount] = useState("");
  // const [inputData, setInputData] = useState({courierId:"",courierName:""});
  const [bankDetails, setBankDetails] = useState();
  const [paymentStatus, setPaymentStatus] = useState();
  const [cartData, setCartData] = useState([]);
  const [purchaseDate, setPurchaseDate] = useState();
  const [purchaseTime, setPurchaseTime] = useState();
  const [DeliveryDate, setDeliveryDate] = useState();
  const [render, setRender] = useState(true);
  const [show, setShow] = useState(false);
  const [render1, setRerender1] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // var list=null;

  function format(x) {
    return x.toString().split(',')[0].length > 3 ? x.toString().substring(0,x.toString().split('.')[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + x.toString().substring(x.toString().split('.')[0].length-3): x.toString();
}
const formatter = new Intl.NumberFormat('en-IN', {maximumSignificantDigits: 3 })
  // const generatePDF = () => {
  //   var divContents = document.getElementById("htmlContent").innerHTML;
  //           var a = window.open('', '', 'height=500, width=500');
  //           a.document.write('<html>');
  //           a.document.write('<body >  ');
  //           a.document.write(divContents);
  //           a.document.write('</body></html>');
  //           a.document.close();
  //           a.print();
  //           a.close();

  //   };

  const notiRef = useRef();
  const styles = StyleSheet.create({
    page: { backgroundColor: 'tomato' },
    section: { color: 'white', textAlign: 'center', margin: 30 }
  });

  function notify(msg, type) {
    var type = type;
    var options = {};
    options = {
      place: "tc",
      message: (
        <div className="notification-msg">
          <div className="text-center">{msg}</div>
        </div>
      ),
      type: type,
      icon: "",
      autoDismiss: 3,
    };
    notiRef.current.notificationAlert(options);
  }
  const handleSubmit=(e)=> {
    // e.target.preventDefault();

    api
      .post("/admin/orders/editPending", { paymentStatus: paymentStatus1,orderStatus:orderStatus1,paidAmount:paidAmount, orderId: params.id })
      // .post("/admin/product/addProduct",{...data,customizationInputs:customizationInputs})
      .then((res) => {
        Swal.fire({
          icon: "success",
          timer: 4000,
          buttons: false,
          showConfirmButton: false,
          text: res.data.data,
        }).then((data) => {
          window.location.href="/orders";
          // setTimeout(() => {
          //   setErr("");
          // }, 5000);
        })
       
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          timer: 4000,
          buttons: false,
          showConfirmButton: false,
          text: err.response.data.error.message,
        });
        console.log(err);
      });
  }

  // const handlePrint = ()=>{

  //   var source = window.document.getElementsByTagName("body")[0];
  //   var specialElementHandlers = {
  //       '#hidden-element': function (element, renderer) {
  //           return true;
  //       }
  //   };
  //   var doc = new jsPDF({
  //       orientation: 'landscape'
  //   });

  //   doc.fromHTML(document.getElementById("#hidden-element").innerHTML, 15, 15, {
  //       'width': 170,
  //       'elementHandlers': specialElementHandlers
  //   });
  // }

  const header = [
    { title: "ID", prop: "id", sortable: true, filterable: true },
    {
      title: "Product Name",
      prop: "productName",
      sortable: true,
      filterable: true,
    },
    {
      title: "Tax Percentage",
      prop: "tax",
      sortable: true,
      filterable: true,
    },
    {
      title: "Total Amount",
      prop: "totalPrice",
      sortable: true,
      filterable: true,
    },
    {
      title: "Quantity",
      prop: "units",
      sortable: true,
      filterable: true,
    },
    {
      title: "Variant Image",
      prop: "variantImage",
      sortable: true,
      filterable: true,
    },
    {
      title: "Variant Color",
      prop: "variantColor",
      sortable: true,
      filterable: true,
    },
    { title: "Timestamp", prop: "createdAt", sortable: true, filterable: true },
  ];

  function handleChange1(info, e) {
    console.log(info.id, e.target.value);
    setPaymentStatus1(e.target.value);
  
  }
  function handleChange2  (info, e) {
    console.log(info.id, e.target.value);
    setOrderStatus1(e.target.value);
  
  }
  function handleChange3  (info, e) {
    console.log(info.id, e.target.value);
    setPaidAmount(e.target.value);
  
  }
  
  const body = [
    {
      id: 1,
      name: "Helen Banks",
      company: "Brainlounge",
      email: "hbanks0@networkadvertising.org",
      phone: "386-(842)278-0044",
      date: moment().subtract(1, "days").format("Do MMMM YYYY"),
    },
    {
      id: 2,
      name: "Russell Wright",
      company: "Trilith",
      email: "rwright1@istockphoto.com",
      phone: "63-(139)594-8042",
      date: moment().subtract(2, "days").format("Do MMMM YYYY"),
    },
  ];
  const customLabels = {
    first: "<<",
    last: ">>",
    prev: "<",
    next: ">",
    show: "Display ",
    entries: " rows",
    noResults: "There is no data to be displayed",
  };

  useEffect(() => {
    api
      .post("/admin/orders/pendingDetails", { orderId: params.id })
      .then((res) => {
        console.log("cart data", res.data.data.fetchCart.singleProductPrice)
        setData(res.data.data);
        setRender(!render);
        {}
        setBankDetails(Number(res.data.data.fetchOrder.paidAmount));
        setCartData(res.data.data.fetchCart)
        setPaymentStatus(res.data.data.fetchOrder.paymentStatus);
        setOrderStatus(res.data.data.fetchOrder.paymentStatus);
        setCourierIdData(res.data.data.fetchOrder.trackingInfo)
        setPurchaseDate(moment(res.data.data.fetchOrder.createdAt).format(('MMMM D, YYYY, h:mm:ss a')));
        setPurchaseTime();
        setDeliveryDate(moment(res.data.data.fetchOrder.updatedAt).format(('MMMM D, YYYY, h:mm:ss a')));
        setTable(
          res.data.data.fetchCart.map((info,i) => ({
            ...info,
            id:i+1,
            productName:(<span style={{ textTransform:"capitalize"}}>{info.productName}</span>),
            variantImage: (
              <img
                src={process.env.REACT_APP_BASEDIR + info.variantImage}
                width={83}
                height={83}
                alt="Variant Image"
              />
            ),
            createdAt: moment(info.createdAt).format(
              "MMM D ddd Y, h:mm:ss a"
            ),
            variantColor: (
              <ColorPicker
                animation="slide"
                color={info.variantColor}
                className="color-css"
              />
            ),
          }))
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
//   console.log("cartsss", cartData);
//   let datas = courierIdData.split("")
//   let data1 = datas[0];
//   let data2 = datas[1];
  const bankData = [
    {
      // content: "\f47f",
      title: "Delivery Type",
      data: "deliveryType",
    },
    {
      // content: "\f47f",
      title: "Order Id ",
      data: "orderId",
    },
    {
      // content: "\f47f",
      title: "Order Status ",
      data: "orderStatus",
    },
    {
      // content: "\f47f",
      title: "Paid Amount ",
      data: "paidAmount",
    },
    {
      // content: "\f47f",
      title: "Payment Mode ",
      data: "paymentMethod",
    },
    {
      // content: "\f47f",
      title: "Payment Status ",
      data: "paymentStatus",
    },
    {
      // content: "\f47f",
      title: "Transaction Id ",
      data: "paymentTransactionId",
    },
    {
      // content: "\f47f",
      title: "Total Amount ",
      data: "totalAmount",
    },
    {
      // content: "\f47f",
      title: "Transaction Status ",
      data: "txnStatus",
    },
   
   
  ];

  function checkArray(data) {
    if (Array.isArray(data) && data !== null) return data;
    else if (typeof data === "object") return [data];
    else return [];
  }
  console.log("data", checkArray(data));

  return (
    <div>
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <div className="page-title">
              <div className="float-left">
                <h1 className="title">Cancelled Order Details</h1>
              </div>
            </div>
           


            {/* Mid card */}

            <div className="container-fluid">
              {/* <div className="row"> */}
              {checkArray(data).map((info) => (
                <section className="box profile-page">
                  <div className="content-body">
                    <div className="row">

                      <div className="col-lg-8">
                        <div className="container-fluid pl-3" >
                          <div className="uprofile">
                            <div className="d-flex justify-content-center">
                              <div className="uprofile-image mb-3">
                                <h3>Profile Details</h3>
                                <img
                                  alt=""
                                  src="data:image/jpeg;base64,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"
                                  className="img-fluid"
                                  style={{borderRadius:"15px",marginLeft:"23px"}}
                                  width={100}
                                  height={100}
                                />
                                 <h4 className="uprofile-owner" style={{ textTransform: "capitalize" }}>
                                Name : {info.fetchUser.userName}
                              </h4>
                              <p className="uprofile-title" style={{ textAlign: "center" }}>
                                Created At :{" "}
                                {moment(info.fetchUser.createdAt).format(
                                  "MMM D ddd Y"
                                )}
                              </p>
                              </div>

                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-6">
                             
                              <ul style={{paddingLeft:"13rem"}}>

                                <li>{info.fetchUser.phone}</li>
                                <li>{info.fetchUser.email}</li>
                                <li
                                  style={{
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {info.fetchUser.gender}
                                </li>
                                <li
                                  style={{
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {info.fetchUser.dob}
                                </li>
                                <li
                                  style={{
                                    textTransform: "capitalize",
                                  }}
                                >
                                  Email verified :
                                  {info.fetchUser.isMailVerified}
                                </li>
                                <li
                                  style={{
                                    textTransform: "capitalize",
                                  }}
                                >
                                  Mobile verified :
                                  {info.fetchUser.isPhoneVerified}
                                </li>
                                {info.fetchAddress !== null ? (
                                  <>
                                    <li
                                      style={{
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {" "}
                                      Address Type :
                                      {info.fetchAddress.addressType}
                                    </li>
                                    <li
                                      style={{
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {" "}
                                      Primary Address :
                                      {info.fetchAddress.primary}
                                    </li>
                                    <li
                                      style={{
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {info.fetchAddress.street}
                                    </li>
                                    <li
                                      style={{
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {info.fetchAddress.landmark}
                                    </li>
                                    <li
                                      style={{
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {info.fetchAddress.city +
                                        " ," +
                                        info.fetchAddress.zipcode}
                                    </li>
                                    <li
                                      style={{
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {info.fetchAddress.district +
                                        " , " +
                                        info.fetchAddress.state}
                                    </li>
                                  </>
                                ) : false
                                // (
                                //   <li
                                //     style={{
                                //       textTransform: "capitalize",
                                //       listStyle: "none",
                                //     }}
                                //   >
                                //     No Address Found
                                //   </li>
                                // )
                                
                                }
                              </ul>
                            </div>
                            <div className="col-lg-6">

                              <div className="container-fluid pl-5" >
                               
                                {/* <ul class="bank">
                                  {bankData.map((data, i) =>
                                    i < 20 ? (
                                      <>
                                        <li
                                          style={{
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          {data.title} :{" "}
                                          {info.fetchOrder[data.data]}
                                        </li>
                                      </>
                                    ) : (
                                      ""
                                    )
                                  )}
                                </ul> */}
                                <div className="row">
                                  <div className="col-lg-12">
                                  Payment Status :    <select
                      style={{ textTransform: "capitalize" }}
                      onChange={(e) => handleChange1(data, e)}
                    >
                      <option>Update Status</option>
                      {/* <option>{data.orderStatus}</option> */}
                      <option value="success">Success</option>
                      <option value="failed">Failed</option>
                      <option value="refunded">Refunded</option>
                      {/* <option value="packaging">Packaging</option>
                      <option value="dispatched">Dispatched</option>
                      <option value="delivered">Delivered</option>
                      <option value="declined">Declined</option> */}
                    </select>
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <div className="col-lg-12">
                                  &nbsp;&nbsp;&nbsp;Order  Status :&nbsp;&nbsp; <select
                      style={{ textTransform: "capitalize" }}
                      onChange={(e) => handleChange2(data, e)}
                    >
                      <option>Update Status</option>
                      {/* <option>{orderStatus}</option> */}
                      {/* <option>{data.orderStatus}</option> */}
                      <option value="declined">Declined</option>
                      <option value="pending">Pending</option>
                      <option value="accepted">Accepted</option>
                      <option value="packaging">Packaging</option>
                      <option value="dispatched">Dispatched</option>
                      <option value="delivered">Delivered</option>
                      {/* <option value="packaging">Packaging</option>
                      <option value="dispatched">Dispatched</option>
                      <option value="delivered">Delivered</option>
                      <option value="declined">Declined</option> */}
                    </select>
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <div className="col-lg-12">

                                &nbsp;&nbsp; Paid Amount :&nbsp; <input type="text" name="paidAmount" value={paidAmount} onChange={(e) => handleChange3(data, e)} />

                                <button class="btn btn-secondary btn-icon bottom15 right15 mt-3" style={{marginLeft:"60px"}} onClick={() => handleSubmit()}>Submit</button>
                                  </div>

                        

                                </div>
                            
                           
                              </div>


                            </div>
                          </div>


                        </div>

                     
                      </div>

                      <div className="col-lg-4">
                        <div className="uprofile">
                          <div className="d-flex justify-content-center">
                          <div style={{paddingTop:"10rem",paddingBottom:"3rem"}}>
                     

                    
                    </div>
                            {/* <div className="uprofile-image">
                              <h3>Update Tracking</h3>
                              <img
                                alt=""
                                src={process.env.REACT_APP_BASEDIR + info.fetchUser.profilePic}
                                className="img-fluid"
                                width={100}
                                height={100}
                              />
                            </div> */}
                          </div>
                        </div>
                        {/* <Form onSubmit={handleSubmit}>
                          <h4>Add Tracking Information</h4>
                                    <FormGroup>
                               
                                      <Input
                                        type="text"
                                        name="courierId"
                                       
                                        id="exampleEmail7"
                                        placeholder="Enter Courier Id"
                                        onChange={(e) => setCourierId(e.target.value)}
                                      />
                                    </FormGroup>
                                    <FormGroup>
                                     
                                      <Input
                                        type="text"
                                        name="courierName"
                                      
                                        id="exampleEmail7"
                                        placeholder="Enter Courier Name"
                                        onChange={(e) => setCourierName(e.target.value)}
                                      />
                                    </FormGroup>
                                    <FormGroup style={{ marginBottom: "0px" }}>
                                      <button type="submit" className="btn btn-primary">
                                        Submit
                                      </button>
                                    </FormGroup>
                                  </Form>  */}
                      </div>
                    </div>
                  </div>
                </section>
              ))}
            </div>
            {/* </div> */}
            {/* Mid card end */}
            <div className="row">
              <div className="col-xl-12 col-md-12 col-sm-12">
                <section className="box ">
                  <header className="panel_header">
                    <h2 className="title float-left">Product Lists</h2>
                  </header>
                  <div className="content-body">
                    <div className="row">
                      <div className="col-lg-12 dt-disp">
                        <Datatable
                          tableHeader={header}
                          tableBody={table}
                          keyName="userTable"
                          tableClass="striped table-hover table-responsive"
                          rowsPerPage={10}
                          rowsPerPageOption={[5, 10, 15, 20, 30]}
                          initialSort={{ prop: "id", isAscending: true }}
                          //   onSort={onSortFunction}
                          labels={customLabels}
                        />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ViewCancelOrders;

// {checkArray(data).length > 0
//   ? checkArray(data).map((info) => (
//       <div className="col-xl-6 col-md-6 col-sm-6">
//         <section className="box profile-page">
//           <div className="col-12">
//             <div className="uprofile">

//             </div>
//           </div>
//         </section>
//       </div>
//     ))
//   : ""}
